import type { Item } from './types'

/**
 * Casse et accents écrasés : en français, chercher « vehicule » doit trouver
 * « Véhicule ». Sans ça la recherche rate une fois sur deux.
 */
export const fold = (s: string) =>
  s
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '')
    .toLowerCase()

/**
 * Tout ce que l'utilisateur a écrit sur la tâche. Le domaine et le statut sont
 * exclus : ils se filtrent par les chips, les inclure ferait remonter 36 tâches
 * sur « ecommerce » et noierait le résultat cherché.
 */
export function matches(item: Item, needle: string): boolean {
  const q = fold(needle.trim())
  if (!q) return true
  const hay = fold(
    [item.title, item.next_action ?? '', item.note ?? '', ...item.comments.map((c) => c.text)].join(' '),
  )
  // Tous les mots doivent être présents, dans n'importe quel ordre : « photos
  // luminaires » trouve « Prendre les photos des luminaires restants ».
  return q.split(/\s+/).every((w) => hay.includes(w))
}
